import React from 'react';
import { Equation } from '../Equation';
import { Lessons } from '../../Lessons';
import './Test.scss';

/*
  props:
    testName  - section ID, e.g. "4b"
    onClose   - called when overlay or close button is clicked
*/
export class BlankTestView extends React.Component {
  onPrint = () => {
    const section = Lessons.getLessonSection(this.props.testName);
    const prevTitle = document.title;
    document.title = section ? section.name : this.props.testName;
    window.print();
    document.title = prevTitle;
  }

  render() {
    const { testName, onClose } = this.props;

    const section = Lessons.getLessonSection(testName);
    if (!section) return null;
    const testPage = section.pages.find(p => p.type === 'test');
    if (!testPage) return null;

    const questions = testPage.testQuestions;

    return (
      <div className="cr-modal-overlay cr-blank-test-overlay" onClick={onClose}>
        <div className="cr-modal cr-blank-test-modal" onClick={e => e.stopPropagation()}>
          <div className="cr-modal-header cr-blank-test-header">
            <span className="cr-modal-title">
              {section.name}
            </span>
            <div className="cr-modal-header-actions">
              <button className="cr-print-button" onClick={this.onPrint}>Print</button>
              <button className="cr-modal-close" onClick={onClose}>&times;</button>
            </div>
          </div>
          <div className="cr-modal-body cr-blank-test-body">
            <div className="testContainer">
              <div className={`questions questions-${questions.length}`}>
                {questions.map((question, index) => (
                  <div key={`bt-${index}`}>
                    <Equation
                      className="testEquation"
                      testComplete={false}
                      equation={{
                        x: { value: question.x },
                        y: { value: question.y },
                      }}
                      reportResult={() => {}}
                    />
                    <div className="correctAnswer">&nbsp;</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
